import AdminList from "@/components/Admin/AdminList/AdminList.vue";
import ThirdPartySystemEdit from "@/components/Admin/ThirdPartySystemEdit/ThirdPartySystemEdit.vue";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import { debounce } from "lodash";
import ClientEdit from "@/components/Admin/ClientEdit/ClientEdit";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "ThirdPartySystemsAdmin",
  components: {
    ClientEdit,
    AdminList,
    ThirdPartySystemEdit
  },

  data: () => ({
    headers: [
      { text: "Name", value: "name" },
      { text: "Type-ID", value: "typeId" },
      { text: "Module", value: "moduleString" },
      { text: "", value: "actionChange", sortable: false }
    ],
    defaultFilter: { searchText: "", itemsPerPage: 25 },
    filter: {},
    showEditDialog: false,
    defaultItem: {
      name: "",
      typeId: "",
      modules: []
    },
    editedItem: {}
  }),
  async mounted() {
    this.editedItem = Object.assign({}, { ...this.defaultItem });
    this.filter = this.defaultFilter;
    this.filter.itemsPerPage = this.defaultFilter.itemsPerPage;
    try {
      await this.applyFilter(this.filter);
    } catch (err) {
      await this.$store.dispatch("createError", err.message);
    }
  },
  computed: {
    thirdPartySystems() {
      return this.$store.state.thirdPartySystems
        .map(obj => {
          obj.moduleString = obj.modules.map(module => module.type).join(", ");
          return obj;
        })
        .map(system => ({ ...system, active: !system.deleted }));
    }
  },
  methods: {
    editItem(item) {
      this.editedItem = item || { ...this.defaultItem };
      this.showEditDialog = true;
    },
    async deleteItem(item) {
      const isConfirmed = await this.$confirm(
        `Wollen Sie die Informationen zum Fremdsystem wirklich löschen?`,
        confirmWarningConfig
      );
      if (!isConfirmed) {
        return;
      }
      try {
        const headers = getTokenHeader();
        await axios.delete(
          `${env.auth_api_client_url}thirdPartySystems/delete`,
          {
            params: {
              id: item._id
            },
            headers
          }
        );
        await this.applyFilter(this.filter);
      } catch (err) {
        await this.$store.dispatch("createError", err.message);
      }
    },
    closeEditDialog() {
      this.editedItem = Object.assign({}, { ...this.defaultItem });
      this.showEditDialog = false;
    },
    async saveEditedItem(editedItem) {
      const headers = getTokenHeader();
      let response, successText;
      if (editedItem._id) {
        try {
          successText = "Erfolgreich gespeichert";
          response = await axios.put(
            `${env.auth_api_client_url}thirdPartySystems/update/`,
            editedItem,
            {
              headers
            }
          );
        } catch (err) {
          await this.$store.dispatch("createError", err.message);
        }
      } else {
        successText = "Erfolgreich angelegt";
        try {
          response = await axios.post(
            `${env.auth_api_client_url}thirdPartySystems/add/`,
            editedItem,
            {
              headers
            }
          );
        } catch (err) {
          await this.$store.dispatch("createError", err.message);
        }
      }
      if (response?.status === 200 || response?.status === 201) {
        await this.$store.dispatch("createSuccess", successText);
        this.closeEditDialog();
        await this.applyFilter(this.filter);
      }
    },
    async applyFilter(filter) {
      if (!filter) filter = this.filter;
      if (filter.limit) delete filter.limit;
      await this.$store.dispatch("getThirdPartySystems", filter);
    },
    applySearchText: debounce(async function() {
      if (this.filter.searchText.length >= 3 || !this.filter.searchText.length)
        await this.applyFilter(this.filter);
    }, 500)
  }
};
